import React from 'react'
import { ImageBackground, StyleSheet } from 'react-native'

import { B5, CTN, H5, SH2, Stack, XStack } from '@zet/design-system'
import { i18n } from '@zet/localization'
import { DEVICE_WIDTH } from '@zet/utils/Constants'
import { BannerProps, useSubscriptionStore } from '@zet/zet-prime'
import { Image } from 'expo-image'
import moment from 'moment'
import Svg, { Line } from 'react-native-svg'

import { SUBSCRIPTION_STATUS } from '../utils/constants'

export default function Banner({
  banner,
  bannerText,
  bannerStrip,
}: BannerProps) {
  const subscription = useSubscriptionStore((state: any) => state.subscription)
  return (
    <ImageBackground
      resizeMode="contain"
      source={{ uri: banner }}
      style={styles.bannerContainer}
    >
      {[SUBSCRIPTION_STATUS.ACTIVE, SUBSCRIPTION_STATUS.CANCELLED].findIndex(
        (element) =>
          element.toLowerCase() === subscription?.status?.toLowerCase(),
      ) === -1 ? (
        <Stack className="mb-4">
          <H5 className="mb-2 px-4 text-center text-warning-200 font-bold">
            {bannerText}
          </H5>
          <Image
            source={{ uri: bannerStrip }}
            contentFit="contain"
            style={styles.bannerStrip}
          />
        </Stack>
      ) : (
        <Stack className="border border-[#CC6A14] rounded-[14px] px-4 py-3 mx-4 mb-7 ">
          <XStack className="justify-between items-center w-full py-1">
            <B5 className="text-grays-70 font-normal">
              {i18n.t('zetPrime.subscriptionStatus')}
            </B5>
            <SH2
              className={`${subscription?.status === SUBSCRIPTION_STATUS.ACTIVE ? 'text-[#27A430]' : 'text-error-150'} font-bold`}
            >
              {subscription?.status}
            </SH2>
          </XStack>
          <Divider />
          <XStack className="justify-between items-center mt-1 w-full py-1">
            <B5 className="text-grays-70 font-normal">
              {i18n.t('zetPrime.nextBillingDate')}
            </B5>
            <Stack className="items-end">
              <SH2 className="text-[#774E2A] font-bold">
                {moment(subscription?.validTill).format('DD MMM YYYY')}
              </SH2>
              <CTN className="text-warning-150">
                {i18n.t('zetPrime.maintainSufficientBalance')}
              </CTN>
            </Stack>
          </XStack>

          <Divider />

          <XStack className="justify-between items-center mt-1 w-full py-1">
            <B5 className="text-grays-70 font-normal">
              {i18n.t('zetPrime.earningsWithZetPrime')}
            </B5>
            <SH2 className="text-[#774E2A] font-bold">
              {'₹' + subscription.earningsTillDate}
            </SH2>
          </XStack>
        </Stack>
      )}
    </ImageBackground>
  )
}

const Divider = () => {
  return (
    <Stack
      style={{
        width: DEVICE_WIDTH - 100,
        height: 1,
        justifyContent: 'center',
      }}
    >
      <Svg height="1" width="100%" viewBox={`0 0 ${DEVICE_WIDTH - 105} 1`}>
        <Line
          x1="0"
          y1="0"
          x2={DEVICE_WIDTH - 100}
          y2="0"
          stroke="#E9DCD1"
          strokeWidth="1"
          strokeDasharray="4,4"
        />
      </Svg>
    </Stack>
  )
}

const styles = StyleSheet.create({
  bannerContainer: {
    alignItems: 'flex-end',
    justifyContent: 'flex-end',
    backgroundColor: 'white',
    height: 510,
    width: DEVICE_WIDTH,
  },
  bannerStrip: {
    height: 68,
    width: DEVICE_WIDTH,
    marginBottom: 16,
  },
  divider: {
    borderWidth: 0.4,
    borderStyle: 'dashed',
    borderColor: '#E9DCD1',
  },
})
